
export const placeholderReplace = (text: string, dictionary: any) => {
    return text ? text.replace(/{\w+}/g, (word) => word in dictionary ? dictionary[word] ? dictionary[word] : 'N/A' : 'N/A') : 'N/A';
}

export const replaceCount = (str, param) => {
    return str.replace(/{count}/g, param);
  }

export function replaceParameters(str: any, parameters: any) {

  let ordinalValue;
  // Replace each parameter in the message
  for (const [key, value] of Object.entries(parameters)) {
    const placeholder = `{${key}}`;
    if (placeholder === '{customerJobOrderNumber}') {
      ordinalValue = getOrdinal(value);
    } else {
      ordinalValue = value
    }
    str = str.replaceAll(placeholder, ordinalValue);
  }
  return str;
}

function getOrdinal(n) {
  const num = +n;
  if (isNaN(num)) {
    return n;
  }

  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = num % 100;

  return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}




// WEBPACK FOOTER //
// ./src/services/string-helper.ts